/* eslint-disable react/prop-types */
export const staticPlansUiSchema = {
  protectionPlans: {
    New: {
      purchase: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            classNames: 'nested-form-group-content',
            items: {
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
                'ui:widget': 'textarea',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
            },
          },
        },
      },
      cash: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            items: {
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
      lease: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            items: {
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
    },
    Used: {
      purchase: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            items: {
              classNames: 'nested-form-group-content',
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
      cash: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            classNames: 'nested-form-group-content',
            items: {
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
    },
    CPO: {
      purchase: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            items: {
              classNames: 'nested-form-group-content',
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
      cash: {
        classNames: 'nested-form-group',
        items: {
          classNames: 'col-md-12',
          content: {
            classNames: 'nested-form-group-content',
            items: {
              headline: {
                classNames: 'col-md-6',
              },
              term: {
                classNames: 'col-md-6',
              },
              deductible: {
                classNames: 'col-md-6',
              },
              cost: {
                classNames: 'col-md-6',
              },
              info: {
                classNames: 'col-md-12 protection-plans-info',
              },
            },
          },
        },
      },
    },
  },
};
